<template>
  <div fluid>
    <HeaderBar>
      <v-icon slot="icon">add</v-icon>
      Add Location {{ addingUnderParent && parent ? `To ${parent.name}` : "" }}
    </HeaderBar>

    <v-layout row>
      <v-flex grow class="mr-2">
        <v-layout column>
          <v-layout row>
            <v-flex class="mr-2">
              <v-text-field v-model="name" label="Location Name"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex class="mr-2">
              <v-autocomplete
                :items="geotagStates"
                label="Add this workstie location to Geo Tag (not required)"
                v-model="worksiteGeotagSelection"
                clearable
                class="mr-2"
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-autocomplete
              label="Parent Business"
              :items="possibleClientBusinesses"
              item-text="name"
              item-value="id"
              hint="The new location will be added under this business"
              persistent-hint
              :disabled="addingUnderParent"
              v-model="clientBusinessId"
            >
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex shrink>
        <v-layout column>
          <v-flex>
            <v-btn
              @click="createLocation()"
              block
              :disabled="!newLocationValid || apiCallPending"
              :loading="apiCallPending"
              color="success"
            >
              Save &amp; Create
            </v-btn>
          </v-flex>
          <v-flex> </v-flex>
          <div v-if="this.clientBusinessId">
            <v-btn
              :to="{
                name: 'clientBusinessDetail',
                params: { clientBusinessId: this.clientBusinessId }
              }"
              block
              color="error"
              :disabled="apiCallPending"
            >
              Cancel
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              to="/hr/locations"
              block
              color="error"
              :disabled="apiCallPending"
            >
              Cancel
            </v-btn>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-flex class="mt-4">
      <h2 class="headline">
        Add Employees by Geo Tag (<span class="subtle">not required</span>)
      </h2>
      <v-autocomplete
        :items="geotagStates"
        label="Geo Tags"
        v-model="geotagSelection"
        clearable
        class="mr-4"
      >
      </v-autocomplete>
    </v-flex>
    <p class="subtle mt-4">
      You will be able to add all other details after saving
    </p>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import HeaderBar from "@/components/base/header-bar.vue";
import collectionsApi from "@/api/collections";
import locationApi from "@/api/location";

export default {
  components: {
    HeaderBar
  },
  created() {
    this.setUp();
  },
  watch: {},
  computed: {
    ...mapState("userAuth", ["user"]),
    newLocationValid() {
      if (this.name && this.clientBusinessId) {
        return true;
      }
      return false;
    }
  },
  methods: {
    setUp() {
      this.getPossibleClientBusinesses();

      collectionsApi.getGeotagStates({}, states => {
        this.geotagStates = states;
      });
    },
    getPossibleClientBusinesses() {
      collectionsApi.getClientBusinesses(clientBusinesses => {
        this.possibleClientBusinesses = clientBusinesses;
        if (this.$route.query.clientBusinessId) {
          this.clientBusinessId = parseInt(this.$route.query.clientBusinessId);
          this.parent = this.possibleClientBusinesses.find(
            cb => cb.id == this.clientBusinessId
          );
          this.addingUnderParent = true;
        }
      });
    },
    createLocation() {
      this.apiCallPending = true;
      locationApi.create(
        {
          name: this.name,
          client_business_id: this.clientBusinessId,
          geotagSelection: this.geotagSelection,
          worksiteGeotagSelection: this.worksiteGeotagSelection
        },
        res => {
          const message = `Created location ${this.name}!`;
          this.$store.dispatch("global/showSnackbarSuccess", {
            message: message
          });
          this.$router.push({
            name: "clientBusinessDetail",
            params: { clientBusinessId: res.clientBusinessId }
          });
          this.apiCallPending = false;
        },
        err => {
          const message = `Something went wrong creating that location...`;
          this.$store.dispatch("global/showSnackbarError", {
            message: message
          });
          this.apiCallPending = false;
        }
      );
    }
  },
  data: function() {
    return {
      possibleClientBusinesses: [],
      parent: {},
      addingUnderParent: false,
      name: "",
      clientBusinessId: "",
      apiCallPending: false,
      geotagStates: [],
      geotagSelection: null,
      worksiteGeotagSelection: null
    };
  }
};
</script>

<style scoped></style>
